import GetAppIcon from '@material-ui/icons/GetApp';
import DeleteIcon from '@material-ui/icons/Delete';
import { ENTITLEMENTS as APPENTITLEMENTS } from '../../core/utils/constants';
import { ENTITLEMENTS } from '../../application-core/constants';
import Paging from '../Paging';
import ActionText from '../../core/ActionText';
import Errored from '../Errored';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import HistoryIcon from '@material-ui/icons/History';
import { NS_GS } from '../utils/constants';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import GS from '../../grafsync/grafsync';
import Loading from '../Loading';
import HistoryDialog from '../HIstoryDialog';
import { globalStyles as styles } from '../style/gstheme';
import { displayDate, displayUser, makeCancelable } from '../utils/utils';
import VersionDownloadDialog from './VersionDownloadDialog';

const PAGE_SIZE = 5;

class VersionDetail extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            page: 1,
            getSnapshotInfo: false,
            isLoadingVersions: true,
            downloadTitle: "",
            historyIRI: null,
            downloadIRI: null,
            startTimestamp: null,
            versions: [],
            deletedProjects: [],
            pageCount: 1,
            isErrored: null
        };
        this.cancellable = null;
    }

    componentDidMount() {
        this.loadVersions();
    }

    loadVersions = async (page = 1) => {
        this.setState({ isLoadingVersions: true }, async () => {
            try {
                GS.handle("load-versions");
                const data = await this.doSearch({
                    search: [
                        {
                            predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
                            value: NS_GS + this.props.projectType
                        },
                        {
                            predicate: "https://grafsync.graphifi.com/schema/gs/isVersionOfProject",
                            value: this.props.projectIRI
                        },
                        {
                            predicate: "https://grafsync.graphifi.com/schema/gs/isValidVersion"
                        }
                    ],
                    exclude: this.state.deletedProjects,
                    page,
                    pageSize: PAGE_SIZE,
                    basicSort: true,
                    sortOrder: "Descending",
                    sort: ["https://grafsync.graphifi.com/schema/gs/snapshotTime"]
                }).promise;
                if (this.cancellable && this.cancellable.isCancelled()) return;
                let versions = [...data.results];
                this.sortVersions(versions);
                if (versions.length > 0) {
                    const lastVersion = versions[0].snapshotTime;
                    this.props.lastSnapshot(lastVersion);
                }
                else {
                    this.props.lastSnapshot(0);
                }
                this.setState({
                    page,
                    pageCount: data.pageCount,
                    versions,
                    isLoadingVersions: false
                });
            }
            catch (e) {
                if (!this.cancellable || (this.cancellable && !this.cancellable.isCancelled())) this.setState({ isErrored: e });
            }
        });
    };

    sortVersions(snapshots) {
        return snapshots.sort(function (a, b) {
            if (a.snapshotTime > b.snapshotTime) return -1;
            if (a.snapshotTime < b.snapshotTime) return 1;
            return 0;
        });
    }

    doSearch(payload) {
        this.cancellable = makeCancelable(GS.search(payload));
        return this.cancellable;
    }

    componentWillUnmount() {
        if (this.cancellable) this.cancellable.cancel();
    }

    showHistory = (versionIndex) => {
        const version = this.state.versions[versionIndex];
        const historyIRI = version.id;
        const historyGraph = version.inNamedGraph;
        let startTimestamp;
        if (versionIndex < this.state.versions.length - 1) startTimestamp = this.state.versions[versionIndex + 1].snapshotTime;
        this.setState({
            historyIRI,
            historyGraph,
            startTimestamp
        });
    };

    downloadVersion = async (versionIndex) => {
        const version = this.state.versions[versionIndex];
        const downloadIRI = version.id;
        const downloadGraph = version.inNamedGraph;
        this.setState({
            downloadIRI,
            downloadTitle: displayDate(version.snapshotTime, true),
            downloadGraph
        });
    };

    deleteVersion = async (versionIndex) => {
        const version = this.state.versions[versionIndex];
        await GS.loadData([version.id], {}, version.inNamedGraph, false);
        const deletedProjectList = [...this.state.deletedProjects];
        deletedProjectList.push(version.id);
        GS.deleteResource(version.id, version.inNamedGraph);
        this.setState({ deletedProjects: deletedProjectList, isLoading: true }, () => this.loadVersions(1));
    };

    exitHistory = () => this.setState({ historyIRI: null });

    exitDownload = () => this.setState({ downloadIRI: null });

    render() {

        const { classes, exportName, users, historyOption, entitlements, projectType, projectGraph } = this.props;
        const { page, pageCount, versions, isLoadingVersions, historyIRI, downloadIRI, downloadGraph, downloadTitle,
            historyGraph, isErrored, startTimestamp } = this.state;

        if (isErrored) return <Errored dataTest="vd-error" data={isErrored} />;
        if (isLoadingVersions) return <Loading offset="100px" />;

        return (
            <div style={{ backgroundColor: '#ffffff', padding: 8, borderRadius: 4 }}>
                {versions.length === 0 ?
                    <div style={{ height: 120 }}>
                        <ActionText dataTest="no-versions" offset="100px">There are no versions for this project.</ActionText>
                    </div>
                    :
                    <Table data-test="versions-viewer">
                        <TableHead>
                            <TableRow>
                                <TableCell component="th" className={classes.tableHeading}>Name</TableCell>
                                <TableCell component="th" className={classes.tableHeading}>Time</TableCell>
                                <TableCell component="th" className={classes.tableHeading}>Comment</TableCell>
                                <TableCell component="th" className={classes.tableHeading}>User</TableCell>
                                <TableCell component="th" className={classes.tableHeading}>Version Project Graph</TableCell>
                                <TableCell component="th" className={classes.tableHeading}></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {versions.map((item, rowIndex) => {
                                const row = [
                                    item.snapshotName,
                                    displayDate(item.snapshotTime, true),
                                    item.snapshotComment,
                                    item.snapshotUser ? displayUser(users, item.snapshotUser) : "",
                                    item.inNamedGraph,
                                    <span style={{
                                        display: 'inline-block',
                                        width: 120,
                                        textAlign: 'right',
                                        marginTop: 4,
                                        marginBottom: 4
                                    }}>
                                        <Tooltip placement="right" title='View version history'>
                                            <IconButton
                                                onClick={() => this.showHistory(rowIndex)}
                                                data-test="show-history"
                                                size="small"
                                                className={classes.addButton}>
                                                <HistoryIcon />
                                            </IconButton>
                                        </Tooltip>
                                        {entitlements.includes(APPENTITLEMENTS.CAN_EXPORT_PROJECT) &&
                                            <span style={{ marginLeft: 12 }}>
                                                <Tooltip placement="right" title='Download version'>
                                                    <IconButton
                                                        onClick={() => this.downloadVersion(rowIndex)}
                                                        data-test="download-version"
                                                        size="small"
                                                        className={classes.addButton}>
                                                        <GetAppIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </span>
                                        }
                                        {((projectType === "TaxonomyProject" && entitlements.includes(ENTITLEMENTS.CREATE_TAXONOMY_PROJECT))
                                            || (projectType === "OntologyProject" && entitlements.includes(ENTITLEMENTS.CREATE_ONTOLOGY_PROJECT))) &&
                                            <span style={{ marginLeft: 12 }}>
                                                <Tooltip placement="right" title='Delete version'>
                                                    <IconButton
                                                        onClick={() => this.deleteVersion(rowIndex)}
                                                        data-test="delete-version"
                                                        size="small"
                                                        className={classes.addButton}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </span>
                                        }
                                    </span>
                                ];
                                return (
                                    <TableRow key={"row-" + rowIndex} classes={{
                                        root: classes.stripedRow
                                    }}>
                                        {row.map((cell, cellIndex) => {
                                            const spans = [cell];
                                            return <TableCell
                                                key={cellIndex}
                                                className={classes.tableCell}
                                                style={{
                                                    verticalAlign: 'middle'
                                                }}>
                                                <Typography className={classes.tableCellText}>
                                                    {
                                                        spans.map((spanText, spanIndex) => <span className={classes.tableCellLine} key={spanIndex}>{spanText}</span>)
                                                    }
                                                </Typography>
                                            </TableCell>;
                                        }
                                        )}
                                    </TableRow>
                                );
                            }
                            )}
                        </TableBody>
                    </Table>
                }
                {pageCount > 1 &&
                    <div style={{ marginTop: '20px' }}>
                        <Paging page={page} pageCount={pageCount} pageItemsRange={2} handlePageChange={this.loadVersions} />
                    </div>
                }
                {historyIRI && <HistoryDialog
                    open={historyIRI ? true : false}
                    id={historyIRI}
                    projectGraph={projectGraph}
                    graph={historyGraph}
                    startTimestamp={startTimestamp}
                    options={[historyOption]}
                    onExitHistory={this.exitHistory} />
                }
                {downloadIRI && <VersionDownloadDialog
                    open={downloadIRI ? true : false}
                    id={downloadIRI}
                    title={downloadTitle}
                    graph={downloadGraph}
                    exportName={exportName}
                    onExitDownload={this.exitDownload} />
                }
            </div>
        );
    }
}

VersionDetail.propTypes = {
    classes: PropTypes.object,
    lastSnapshot: PropTypes.func.isRequired,
    users: PropTypes.array.isRequired,
    entitlements: PropTypes.array.isRequired,
    historyOption: PropTypes.object.isRequired,
    projectIRI: PropTypes.string.isRequired,
    projectGraph: PropTypes.string.isRequired,
    projectType: PropTypes.string.isRequired
};

export default withStyles(styles)(VersionDetail);